module.exports = __webpack_public_path__ + "static/media/view-day-back.718e4734.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view-day-back.svg
// module id = 909
// module chunks = 35